__turbopack_context__.v({
  "container": "l8d7Bq_container",
  "featuredContainer": "l8d7Bq_featuredContainer",
  "heading": "l8d7Bq_heading",
});
